import { Action } from 'redux';
import { NotificationsActionTypes } from '../notifications.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface RemoveNotificationAction extends Action<NotificationsActionTypes.REMOVE_NOTIFICATION> {
    id: string;
}

export const removeNotification: (id: string) => RemoveNotificationAction = (id: string) => ({
    type: NotificationsActionTypes.REMOVE_NOTIFICATION,
    id
});
removeNotification[ACTION_CREATOR_NAME] = 'removeNotification';

export type RemoveNotificationFunc = (...args: Parameters<typeof removeNotification>) => void;